import Axios from "../apis/axios";
import { produce } from "immer";

const createKpiSlice = (set: (data: any) => void, get: () => any) => ({
  kpiPollingActive: false,
  getKpisData: [],

  

  getKpis: async (nodeids: any) => {
    

    try {
      if (get().isLoggedIn === true) {
        const objNodeIds = { equipmentnodeids: nodeids, lang: get().lang };
        let response = await Axios.post(`api/v1/kpis`, objNodeIds, {
          headers: {
            "Content-Type": "application/json",
          
          },
        });
        if (response !== undefined && Object.keys(response).length) {
         
          if (response.status !== undefined && response.status === 200) {
            set(
              produce((state: any) => {
                state.getKpisData = response.data;
              })
            );
            // Return the response data after updating the state
            return response.data;
          } else {
            throw new Error("Invalid response status");
          }
        } else {
          throw new Error("Empty or undefined response");
        }
      }
    } catch (error) {
      console.error("Error fetching KPIs:", error);
      set(
        produce((state: any) => {
          state.getKpisData = [];
        })
      );
    }
  },
});

export default createKpiSlice;
